import type { VideoPluginEditorConfig } from '@wix/ricos';

type VideoUploadFunc = Exclude<VideoPluginEditorConfig['handleFileSelection'], undefined>;

export const mockCustomVideoUploadFunc: VideoUploadFunc = updateEntity => {
  // eslint-disable-next-line no-console
  console.log('consumer wants to upload custom video');
  const videoToUpload = getVideoToUpload(
    '11062b_a552731f40854d16a91627687fb8d1a6',
    '11062b_a552731f40854d16a91627687fb8d1a6f000.jpg'
  );
  setTimeout(() => {
    updateEntity({ data: videoToUpload });
    // eslint-disable-next-line no-console
    console.log('consumer uploaded ', videoToUpload);
  }, 500);
};

const getVideoToUpload = (url: string, thumbnailUrl: string) => {
  const videoWithRelativeUrl = {
    pathname: `video/${url}/1080p/mp4/file.mp4`,
    thumbnail: {
      pathname: `media/${thumbnailUrl}`,
      height: 1080,
      width: 1920,
    },
  };
  // You can provide either absolute or relative URL.
  // If relative URL is provided, a function 'getVideoUrl' will be invoked to form a full URL.
  return videoWithRelativeUrl;
};
